import { copyToClipboardUsingExtention } from "../../functions/clipboardUtils";
export const copyToAutofill = (order, type, statusTab, downloadData, heading, field) => {
  let selectedTypeId = "";
  if (type === 'CUSTOMER_RETURN') {
    selectedTypeId = `1/1/create`
  } else if (type === 'RTO_RETURN') {
    selectedTypeId = `1/139/create`
  } else if (type === 'NON_BARCODED_RTO') {
    selectedTypeId = `1/140/create`
  } else if (type === 'Damage') {
    selectedTypeId = `1/3/create`
  } else if (type === 'MISSING_QTY') {
    selectedTypeId = `1/2/create`
  } else if (type === 'RTO_RETURN') {
    selectedTypeId = `1/4/create`
  }

  let data = {
    "id": order.id,
    "gstProfileId": order.gstProfileId,
    "subOrderNumber": order.subOrderNumber,
    "description": order.description,
    // "awbNo": order.awbNumber,
    // "packetId": order.packetId
    "awbNo": statusTab === 'COMPLETED' ? order.awbNumber : order.meeshoOrder?.awbNumber,
    "packetId": type === 'RTO_RETURN' ? order.meeshoOrder?.packetId || '-' : order.packetId,
    "packetState": order.stateOfPacket === 'TAMPERED' ? 'Tampered' : order.stateOfPacket === "INTACT" ? 'Intact' : '',
    "type": heading,
    "url": selectedTypeId
  }

  downloadData.forEach((key, index) => {
    data[key] = order[key]
  });
  const jsonData = JSON.stringify(data);

  copyToClipboardUsingExtention(jsonData, field);

  // navigator.clipboard.writeText(jsonData).then(() => {
  //   showSnackbar(`${field} copied successfully!`, "success")
  // }).catch(err => {
  //   showSnackbar(`Failed to copy data`, "error")

  // });
}
